import { CheckIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import Select from "../../../shared/components/Select";
import { ViewProps } from "../certification-broadcast-settings.types";

export default function NewSettingRow(props: ViewProps) {
  return (
    <tr>
      <td>New</td>
      <td>
        <Select
          searchable
          buttonProps={{ width: "100%" }}
          label="Office"
          multiple={false}
          options={props.officeOptions}
          size="sm"
          value={props.newSetting.officeId}
          width="220px"
          onChange={(value) => props.onChangeNewSetting({ officeId: value ?? null })}
        />
      </td>
      <td>
        <Select
          searchable
          buttonProps={{ width: "100%" }}
          isDisabled={props.certificationOptions.length === 0}
          label="Certification"
          multiple={false}
          options={props.certificationOptions}
          size="sm"
          value={props.newSetting.primaryCertification}
          width="220px"
          onChange={(value) => props.onChangeNewSetting({ primaryCertification: value ?? null })}
        />
      </td>
      <td>
        <Select
          searchable
          buttonProps={{ width: "100%" }}
          isDisabled={props.certificationOptions.length === 0}
          label="Permitted"
          multiple={true}
          options={props.certificationOptions}
          size="sm"
          value={
            props.newSetting.permittedCertifications.length > 0
              ? props.newSetting.permittedCertifications
              : null
          }
          width="320px"
          onChange={(value) => props.onChangeNewSetting({ permittedCertifications: value ?? [] })}
        />
      </td>
      <td>
        <Button
          colorScheme="blue"
          isDisabled={props.createDisabled || props.createLoading}
          isLoading={props.createLoading}
          leftIcon={<CheckIcon />}
          size="sm"
          title={props.createTitle}
          onClick={props.onCreate}
        >
          Add
        </Button>
      </td>
    </tr>
  );
}
